var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("i", {
    directives: [
      {
        name: "tooltipped",
        rawName: "v-tooltipped:[tooltip]",
        value: true,
        expression: "true",
        arg: _vm.tooltip
      }
    ],
    staticClass: "far fa-question-circle xs help-popover"
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }